

const ProtectedRoute = ({ user, children }: any) => {
    return children;
};

export default ProtectedRoute;
